import React from 'react';
import { Users2Icon, SendIcon } from 'lucide-react';
import NavItem from './NavItem';
import { usePermissions } from '../../hooks/usePermissions';
import { usePortalBrandContext } from '../../hooks/usePortalBrandContext';
import { useExportsCapabilities } from '../../hooks/api/useExports';

/** Last sidebar group: company settings for the brand in context (Team, Data Exports). */
const CompanyNavGroup: React.FC<{ isCollapsed: boolean }> = ({ isCollapsed }) => {
  const { isBrandAdmin, isAdminOrHigher } = usePermissions();
  const { brandName } = usePortalBrandContext();
  const { data: caps } = useExportsCapabilities();
  const showTeam = isBrandAdmin();
  const showExports = (isBrandAdmin() || isAdminOrHigher()) && caps?.enabled === true;
  if (!showTeam && !showExports) return null;
  return (
    <>
      <div className="border-t border-white/30 my-2" />
      {!isCollapsed && <div className="px-3 pb-1 text-xs text-white/60 truncate">{brandName || 'Company'}</div>}
      <div className="space-y-0.5">
        {showTeam && <NavItem icon={<Users2Icon size={16} />} label="Team" href="/team" isCollapsed={isCollapsed} />}
        {showExports && <NavItem icon={<SendIcon size={16} />} label="Data Exports" href="/company/exports" isCollapsed={isCollapsed} />}
      </div>
    </>
  );
};
export default CompanyNavGroup;
